import lomavisCreator from '../../../redux/slices/lomavisCreator/lomavisCreator';
import {
  ALL_VALIDATORS,
  BUTTONS_VALIDATORS
} from '../config/buttonsValidatorsConfig';
import { postHasPublicationDate } from '../config/buttonsValidatorsFunctions';
import {
  BTN_PLAN_PUBLICATION,
  BTN_PUBLISH_NOW,
  BTN_SAVE,
  BTN_SAVE_AS_DRAFT,
  POST_STATUS_DRAFT,
  POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
  POST_STATUS_READY,
  POST_STATUS_WAITING_FOR_APPROVAL,
  validatorsWithPlatform
} from '../config/constants';
const getButtonValidators = (buttonKey: string, lomavisCreator: any) => {
  let buttonValidators = BUTTONS_VALIDATORS?.[buttonKey]?.validators || [];
  //handling special case for BTN_SAVE
  if (buttonKey === BTN_SAVE) {
    switch (lomavisCreator.post_status) {
      case POST_STATUS_DRAFT:
        buttonValidators = BUTTONS_VALIDATORS[BTN_SAVE_AS_DRAFT].validators;
        break;
      case POST_STATUS_WAITING_FOR_APPROVAL:
        buttonValidators = BUTTONS_VALIDATORS[BTN_SAVE_AS_DRAFT].validators;
        break;
      case POST_STATUS_READY:
        buttonValidators = BUTTONS_VALIDATORS[BTN_PUBLISH_NOW].validators;
        break;
      case POST_STATUS_PROPOSED_BY_EXTERNAL_USER:
        buttonValidators = BUTTONS_VALIDATORS[BTN_SAVE_AS_DRAFT].validators;
        break;
    }
  }
  return buttonValidators;
};

export const checkButtonValidation = (
  lomavisCreator: any,
  buttonKey: string
) => {
  const buttonValidators = getButtonValidators(buttonKey, lomavisCreator);
  const affectedPlatforms = [];
  const errorsList = [];
  buttonValidators.map((validator) => {
    const validatorResults = ALL_VALIDATORS[validator].func(lomavisCreator);

    validatorResults.map(({ isValid, platform }) => {
      if (!isValid) {
        affectedPlatforms.push(platform);
        errorsList.push({
          title: ALL_VALIDATORS[validator].title,
          message: ALL_VALIDATORS[validator].message
        });
      }
    });
  });
  const hasError = errorsList.filter((error) => error).length > 0;
  return {
    // remove duplicates from affectedPlatforms
    affectedPlatforms: affectedPlatforms.filter(
      (platform, index, self) => self.indexOf(platform) === index
    ),

    hasError,
    // remove undefined errors and duplicates
    errorsList: errorsList
      .filter((error) => error)
      .filter(
        (error, index, self) =>
          self.findIndex((e) => e.title === error.title) === index
      )
  };
};

export const handleOnClickValidation = (
  lomavisCreator: any,
  buttonKey: string
) => {
  const buttonValidators = getButtonValidators(buttonKey, lomavisCreator);
  // list of affected platforms + error message and title
  const errorsList = [];
  buttonValidators.map((validator) => {
    let hasError = false;
    const affectedPlatforms = [];
    const validatorResults = ALL_VALIDATORS[validator].func(lomavisCreator);
    validatorResults
      .filter(({ isValid }) => !isValid)
      .map(({ platform }) => {
        hasError = true;
        affectedPlatforms.push(platform);
      });

    if (hasError) {
      errorsList.push({
        title: ALL_VALIDATORS[validator].title,
        message: ALL_VALIDATORS[validator].message,
        affectedPlatforms: validatorsWithPlatform.includes(validator)
          ? affectedPlatforms
          : []
      });
    }
  });
  return errorsList;
};
